import Action from '../../../types/action';
import OverlayActions from './overlay.actions';

export default function close(): Action<OverlayActions> {
  return {
    type: OverlayActions.Close,
  };
}
